import {
  LOGIN_ERROR_401, LOGIN_ERROR_APP_ACTION_CODES, LOGIN_ERROR_CODES,
} from '@m2h/common/constants/apiCode';
import {
  H5_NEW_APIS, H5_NEW_I_APIS, H5_NEW_M_APIS, SHOP_APIS,
} from '@m2h/common/constants/apiUrl';
import { owlAddAjaxInfo } from '@m2h/common/raptor';
import {
  isInApp,
} from '@m2h/common/utils/common';
import {
  getClientType, getEnv, getI18nParams, getLoginUinfo, isFromM, isLocal, toLogin
} from '@m2h/common/utils';
import { getSSOLoginUrl } from '@m2h/common/utils/sso';
import { getChannel, getRequestChannel, isGoogleMapChannel } from '@m2h/common/utils/channelContext';
import Toast from '@roo/roo/Toast';

// import { apiLog } from '@RootCommon/utils/logan';
// import { owlAddAjaxInfo } from '@RootCommon/utils/owl';

// 请求参数格式化为便于日志记录的格式
const parseApiInfo = (response) => {
  const {
    data, config, status, request, headers = {}
  } = response || {};
  const { headers: reqHeader, data: reqData, params } = config || {};
  const { url, method } = request || {};
  const mTraceid = headers['m-traceid'];
  return {
    url,
    mTraceid,
    request: {
      method,
      reqHeader,
      reqData,
      params,
    },
    response: {
      status,
      data,
    },
  };
};

// 请求拦截器：国际化请求头，i18n必须接入
export function addI18nHeader(config) {
  return {
    ...config,
    headers: {
      ...getI18nParams(),
      ...config.headers,
    },
  };
}

// 添加统一的请求前缀
export function addPrefix(config) {
  // @ts-ignore
  const isGoogleMapShopApi = isGoogleMapChannel(getChannel()) && SHOP_APIS.includes(config.url);

  // Google Map 渠道的门店接口优先走免登录网关。
  if (isGoogleMapShopApi) {
    config.url = config.url.replace(/^\/api\/v1\/shop\//, '/api/h5/google/v1/shop/');
    return config;
  }

  // if (isFromM() && config.url.startsWith('/api/v1/')) {
  if (isFromM() && H5_NEW_M_APIS.includes(config.url)) {
    config.url = config.url.replace('/api/v1/', '/api/v1/h5/m/');
    // config.url = config.url.replace('/api/v1/', '/api/h5/m/v1/');
  }
  // @ts-ignore
  // if (Mach.env?.isH5 && H5_NEW_I_APIS.includes(config.url)) {
  //   config.url = config.url.replace(/^\/api\/v1\//, '/api/v1/h5/');
  // }
  // @ts-ignore
  if (Mach.env?.isH5 && H5_NEW_APIS.includes(config.url)) {
    config.url = config.url.replace(/^\/api\//, '/api/h5/');
  }
  return config;
}

// sso 登录校验
export function ssoCheck(response) {
  const { data } = response;
  const { status, code } = data || {};
  if (status === 401 || code === 401 || code === 50102 || code === 30001) {
    // 30001 ssoid 过期
    // 重定向到sso登入页
    // 默认登出后再登录是重定向到应用首页
    if (window.top) {
      window.top.location.href = getSSOLoginUrl();
    } else {
      window.location.href = getSSOLoginUrl();
    }
  }
  return response;
}

// interceptors.response.use
// 响应拦截器：登录信息校验统一拦截器，需要登录后才可请求的接口必须接入
export function loginCheck(response) {
  const { data, config } = response;
  const requestHeaders = config?.headers;
  const {
    status, code, msg, message
  } = data || {};
  // apiLog(parseApiInfo(response));
  const isLoc = isLocal(window.location.host);
  // if (isLoc) return response;
  // 管理app, 端上处理的登录错误码
  if (isInApp() && LOGIN_ERROR_APP_ACTION_CODES.indexOf(+code) !== -1) {
    // knbPublish({ url: response.config.url || '', code, response: JSON.stringify(response)})
    console.log('KNB.publish in', code);
    KNB.publish({
      type: 'native', // 指定native后，无需设置bizname
      action: 'com.sankuai.sailor.partner.account.network.error', // 自定义的action名称，由webview传给native，业务方需根据业务需求增加相应的action处理
      data: { url: response.config.url || '', code, response: JSON.stringify(data) }, // 与native的通信内容，由业务方自由定义data对象体的内容 {code, url}
      success(data) {
        // resolve(data)
        console.log('KNB.publish success', code);
      },
      fail(err) {
        // reject(err)
        console.log('KNB.publish error', code);
        owlAddAjaxInfo(`KNB.publish error code: ${code}`, {
          API: (response.config.url || '').replace(/\?.*$/, ''),
          MSG: `KNB.publish error, ${msg || message || ''}`,
        });
      },
    });
    console.log('KNB.publish', code);
    // passiveLogoutLog()
    throw new Error(`Code: ${code}, ${msg || message}, app login error api code, API: ${(response.config.url || '').replace(/\?.*$/, '')}`);
  }
  try {
    // 直接跳登录
    if (status === LOGIN_ERROR_401 || LOGIN_ERROR_CODES.indexOf(+code) !== -1) {
      // passiveLogoutLog()
      console.log('LOGIN_ERROR_CODES', +code, response.config.url, data);
      owlAddAjaxInfo(`loginCheck error code: ${code}`, { API: (response.config.url || '').replace(/\?.*$/, ''), MSG: msg || message || '', requestHeaders });
      // failToast(i18nClient.getText('account_web:Account_Log_out_remind'), 3500, { maxCount: 1, position: 'topCenter' });
      console.log('toLogin', code, response.config);
      toLogin();
    }
    return response;
  } catch (e) {
    console.log(e);
    owlAddAjaxInfo(e, { API: (response.config.url || '').replace(/\?.*$/, ''), MSG: msg || message || '', requestHeaders });
    return response;
  }
}

const dataTypeToContentType = {
  json: 'application/json; charset=utf-8',
  form: 'application/x-www-form-urlencoded; charset=utf-8',
  string: 'text/plain; charset=utf-8',
};

// 添加公共头部
// 参考文档：https://km.sankuai.com/collabpage/1496459800
export function addCommonHeaders(config) {
  const addConfig = {
    clientType: getClientType(),
  } as any;

  const requestChannel = config.headers?.channel;
  // 使用单接口原有值config.headers?.channel > 页面/sessionstorage channel > iframe/M 端的 bd。
  const channel = getRequestChannel(requestChannel);

  const contentType = config.dataType ? dataTypeToContentType[config.dataType] : dataTypeToContentType.form;
  const uInfo = getLoginUinfo();

  const {
    version: appversion, deviceModel: deviceType,
    uuid, osVersion, bundleVersion,
    // @ts-ignore
    platform, partner,
  } = Mach.env || {};

  return {
    ...config,
    headers: {
      platform,
      partner,
      appversion,
      deviceType,
      osVersion,
      // bundleVersion,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      userid: uInfo.id,
      uuid,
      ...getI18nParams(),
      ...addConfig,
      ...config.headers,
      ...(channel ? { channel } : {}),
      'Content-Type': contentType,
      // clientType: 'c_android',
    },
  };
}

export function errorCode(res) {
  const { data } = res || {};
  const {
    code, msg, message, data: _data
  } = data;
  if (code !== 0) {
    Toast.open({
      duration: 3500,
      theme: 'light',
      position: 'center',
      status: 'fail',
      children: message || msg || '网络异常',
    });
    throw new Error(data);
  } else {
    return _data;
  }
}

// 响应拦截器：返回数据处理拦截器，可选接入
export function returnAllData(response) {
  const { data } = response;
  return data;
}
